import PropTypes from 'prop-types';
import React from 'react';
import { connect as connectR } from 'react-redux';
import { Button, Col, Row } from 'react-bootstrap';
import _ from 'lodash';
import { Link } from 'react-router';
import LargeCard from '../main/large-card';
import translate from '../translate';
import Navbar from '../navigation/navbar';
import TitleCard from '../main/title-card';
import LeftSide from '../main/left-side';
import Postit from '../main/postit';
import { PARTNER_MANAGER_CONTROL } from '../../util/enums';
import ProfileContactDataForm from '../profile/forms/profile-contact-data-form';
import ContactAddressPreview from '../profile/forms/contact-address-preview';
import { MaybeLoadCountries } from '../../store/countriesDetailsSlice';
import {
    LoadAccountingAreaDefaults,
    LoadSupportedTenants,
} from '../../store/accountingAreaDefaultsSlice';
import { REQUEST_FAILURE } from '../../store/network/managedRequest';
import {
    CreatePartner,
    LoadPartners,
    PrepareCreatePartner,
} from '../../store/partnerManagerSlice';
import { goToDashboard, goToSelectPartner } from '../../nav/navigationService';
import ProfileSettlementDetailsFormWrapper from '../profile/forms/profile-settlement-details-form-wrapper';
import PbCardErrorElement from '../main/pb-card-error-element';
import ProfileContractDetailsFormWrapper from '../profile/forms/profile-contract-details-form-wrapper';
import { PbRequest } from '../../store/pbRequest';

const DEFAULT_VALUES = {
    holder: '',
    iban: '',
    bic: '',
};

class CreatePartnerBasicForm extends React.Component {
    static propTypes = {
        strings: PropTypes.shape({
            generalError: PropTypes.string,
            cancel: PropTypes.string,
            descriptionInitialPartnerCreation: PropTypes.string,
            description: PropTypes.string,
            finish: PropTypes.string,
            postitTextInitialPartnerCreation: PropTypes.string,
            postitText: PropTypes.string,
            title: PropTypes.string,
            description2: PropTypes.string,
            iban: PropTypes.string,
            ibanHelp: PropTypes.string,
            ibanError: PropTypes.string,
            bic: PropTypes.string,
            recipientContactDisabled: PropTypes.string,
            recipientContactTitle: PropTypes.string,
            recipientContactDescription: PropTypes.string,
            bicHelp: PropTypes.string,
            bicError: PropTypes.string,
            accountholderNameError: PropTypes.string,
            accountholderNameHelp: PropTypes.string,
            accountholderName: PropTypes.string,
            billing_description: PropTypes.string,
            billing_title: PropTypes.string,
            contractualContactDescription: PropTypes.string,
            contractualContactTitle: PropTypes.string,
            registrationTitle: PropTypes.string,
        }).isRequired,
        userData: PropTypes.shape({ country_id: PropTypes.number }),
        partnerManagerDetails: PropTypes.shape({
            control: PropTypes.oneOf(Object.values(PARTNER_MANAGER_CONTROL)),
        }).isRequired,
        partners: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        createPartnerRequest: PropTypes.shape({
            status: PropTypes.string,
            errors: PropTypes.arrayOf(PropTypes.string),
        }).isRequired,
        MaybeLoadCountries: PropTypes.func.isRequired,
        LoadAccountingAreaDefaults: PropTypes.func.isRequired,
        LoadSupportedTenants: PropTypes.func.isRequired,
        LoadPartners: PropTypes.func.isRequired,
        PrepareCreatePartner: PropTypes.func.isRequired,
        CreatePartner: PropTypes.func.isRequired,
    };

    state = {
        data: {},
        contractDetails: {},
        contractualContact: {},
        contractualContactValid: false,
        recipientContact: null,
        recipientContactValid: true,
        contractDetailsFormValid: false,
        settlementDetails: {},
        settlementDetailsFormValid: false,
    };

    componentDidMount() {
        this.props.MaybeLoadCountries();
        this.props.LoadPartners();
        this.props.LoadAccountingAreaDefaults();
        this.props.LoadSupportedTenants();
        this.props.PrepareCreatePartner();
    }

    getErrorMessage = () => {
        if (REQUEST_FAILURE === this.props.createPartnerRequest.status) {
            return (
                <PbCardErrorElement
                    errors={this.props.createPartnerRequest.errors}
                    standardText={this.props.strings.generalError}
                />
            );
        }
        return null;
    };

    getFieldValue = (fieldName) => {
        if (this.state.data.hasOwnProperty(fieldName)) {
            return this.state.data[fieldName];
        }

        if (
            fieldName === 'email' ||
            (!this.isInitialPartnerCreation() && fieldName !== 'country_id')
        ) {
            return DEFAULT_VALUES[fieldName];
        } else {
            const user = this.props.userData;
            const storeValue = user && user[fieldName];
            return storeValue || DEFAULT_VALUES[fieldName];
        }
    };

    isInitialPartnerCreation = () => {
        return this.props.partners.length === 0;
    };

    isInternalManager = () => {
        return (
            this.props.partnerManagerDetails &&
            this.props.partnerManagerDetails.control ===
                PARTNER_MANAGER_CONTROL.ADMIN
        );
    };

    _handleSubmit = (event) => {
        event.preventDefault();

        if (this._isDataValid()) {
            const contractDetails = this.state.contractDetails;
            const contractual_contact = this.state.contractualContact;
            const credit_note_recipient = this.state.recipientContact;

            const settlementDetails = this.state.settlementDetails;
            const billing = {
                holder: settlementDetails.holder,
                iban: settlementDetails.iban,
                bic: settlementDetails.bic,
            };
            const vat_exempted = contractDetails.vat_exempted;
            if (contractDetails.contractual_type !== 'RMS') {
                contractDetails.pms_provider = null;
            }
            const settlementOptions = {
                contractual_wewash_share:
                    contractDetails.contractual_wewash_share,
                bank_data_available: settlementDetails.useSettlement,
                auto_receive_credit_note: settlementDetails.useEmail,
                receive_credit_note_email: settlementDetails.emailAddress,
                vat_exempted: contractDetails.vat_exempted,
                vat_id: vat_exempted ? null : contractDetails.vat_id,
                tax_number: vat_exempted ? null : contractDetails.tax_number,
                company_registration_number:
                    contractDetails.company_registration_number,
                vat_exemption_reason: vat_exempted
                    ? contractDetails.vat_exemption_reason
                    : null,
                country_id: contractDetails.country_id,
                contractual_type: contractDetails.contractual_type,
                tenant_id: contractDetails.tenant_id,
                pms_provider: contractDetails.pms_provider,
                credit_notes_enabled: settlementDetails.creditNotesEnabled,
            };
            this.props.CreatePartner(
                {
                    billing,
                    settlement: settlementOptions,
                    contractual_contact,
                    credit_note_recipient,
                },
                (numberOfPartners) => {
                    if (numberOfPartners === 1) {
                        goToDashboard();
                    } else {
                        goToSelectPartner();
                    }
                }
            );
        }
    };

    _isDataValid = () => {
        return (
            this.state.contractDetailsFormValid &&
            this.state.contractualContactValid &&
            this.state.recipientContactValid &&
            this.state.settlementDetailsFormValid
        );
    };

    _persist = (field, value) => {
        const data = _.extend({}, this.state.data);
        data[field] = value;
        this.setState({ data });
    };

    _handleContractDetailsChange = ({ _valid, ...contractDetails }) => {
        this.setState({
            contractDetails,
            contractDetailsFormValid: _valid,
        });
    };

    _handleSettlementDetailsChange = ({ _valid, ...settlementDetails }) => {
        this.setState({
            settlementDetails,
            settlementDetailsFormValid: _valid,
        });
    };

    _getContractualCountryId = () => {
        return Number(this.state.contractDetails.country_id);
    };

    _getContractualContact = () => {
        return this.state.contractualContact;
    };

    _handleChangeContractualContact = ({ _valid, contactData }) => {
        this.setState({
            contractualContact: contactData,
            contractualContactValid: _valid,
        });
    };

    _getRecipientContact = () => {
        return this.state.recipientContact;
    };

    _handleChangeRecipientContact = ({ _valid, contactData }) => {
        this.setState({
            recipientContact: contactData,
            recipientContactValid: _valid,
        });
    };

    render() {
        const errorMessage = this.getErrorMessage();

        const getBackArrow = () => ({
            content: (
                <Link
                    to="/select-partner"
                    className="icon icon-wew-arrow-left icon-sm"
                />
            ),
            title: this.props.strings.cancel,
        });

        if (!this.props.userData) {
            return <div />;
        }

        return (
            <Navbar nav hidePartnerSelection={this.isInitialPartnerCreation()}>
                <Row>
                    <LeftSide>
                        <TitleCard
                            title={[this.props.strings.registrationTitle, '']}
                            left={
                                this.isInitialPartnerCreation()
                                    ? undefined
                                    : getBackArrow()
                            }
                        />
                    </LeftSide>
                    <Col xs={9} sm={9} md={9} lg={9} className="col-middle">
                        <Row>
                            <form
                                onSubmit={this._handleSubmit}
                                method="POST"
                                role="form"
                            >
                                <Col xs={8} sm={8} md={8} lg={8}>
                                    <LargeCard
                                        type="card-edit"
                                        title={this.props.strings.title}
                                        description={
                                            this.isInitialPartnerCreation()
                                                ? this.props.strings
                                                      .descriptionInitialPartnerCreation
                                                : this.props.strings.description
                                        }
                                    >
                                        <div className="card-desc">
                                            <p>
                                                {
                                                    this.props.strings
                                                        .description2
                                                }
                                            </p>
                                        </div>

                                        <ProfileContractDetailsFormWrapper
                                            defaultCountryId={
                                                this.props.userData
                                                    ?.country_id ?? undefined
                                            }
                                            internalManager={this.isInternalManager()}
                                            contractDetails={
                                                this.state.contractDetails
                                            }
                                            onChange={
                                                this
                                                    ._handleContractDetailsChange
                                            }
                                        />
                                    </LargeCard>
                                </Col>
                                <Col xs={4} sm={4} md={4} lg={4}>
                                    <Postit>
                                        <p>{this.props.strings.postitText}</p>
                                        {this.isInitialPartnerCreation() && (
                                            <p>
                                                <br />
                                                {
                                                    this.props.strings
                                                        .postitTextInitialPartnerCreation
                                                }
                                            </p>
                                        )}
                                    </Postit>
                                </Col>
                                <Col xs={8} sm={8} md={8} lg={8}>
                                    <LargeCard
                                        type={'card-edit'}
                                        title={
                                            this.props.strings
                                                .contractualContactTitle
                                        }
                                        description={
                                            this.props.strings
                                                .contractualContactDescription
                                        }
                                    >
                                        <ProfileContactDataForm
                                            contactData={this._getContractualContact()}
                                            handleChange={(data) =>
                                                this._handleChangeContractualContact(
                                                    data
                                                )
                                            }
                                        />
                                    </LargeCard>
                                </Col>
                                <Col xs={4} sm={4} md={4} lg={4}>
                                    <Postit>
                                        <ContactAddressPreview
                                            contactData={{
                                                ...this._getContractualContact(),
                                            }}
                                            contractualCountryId={this._getContractualCountryId()}
                                        />
                                    </Postit>
                                </Col>

                                <Col xs={8} sm={8} md={8} lg={8}>
                                    <LargeCard
                                        type="card-edit"
                                        title={this.props.strings.billing_title}
                                        description={''}
                                    >
                                        <div
                                            className="card-desc"
                                            dangerouslySetInnerHTML={{
                                                __html: this.props.strings
                                                    .billing_description,
                                            }}
                                        />

                                        <ProfileSettlementDetailsFormWrapper
                                            settlementDetails={
                                                this.state.settlementDetails
                                            }
                                            onChange={(data) =>
                                                this._handleSettlementDetailsChange(
                                                    data
                                                )
                                            }
                                            internalManager={this.isInternalManager()}
                                        />
                                    </LargeCard>
                                </Col>
                                <Col xs={4} sm={4} md={4} lg={4} />

                                <Col xs={8} sm={8} md={8} lg={8}>
                                    <LargeCard
                                        type={'card-edit'}
                                        title={
                                            this.props.strings
                                                .recipientContactTitle
                                        }
                                        description={
                                            this.props.strings
                                                .recipientContactDescription
                                        }
                                    >
                                        <ProfileContactDataForm
                                            optional
                                            contactData={this._getRecipientContact()}
                                            handleChange={(data) =>
                                                this._handleChangeRecipientContact(
                                                    data
                                                )
                                            }
                                        />
                                        {this.state.recipientContact ===
                                            null && (
                                            <div>
                                                {
                                                    this.props.strings
                                                        .recipientContactDisabled
                                                }
                                            </div>
                                        )}
                                    </LargeCard>
                                </Col>
                                <Col xs={4} sm={4} md={4} lg={4}>
                                    <Postit>
                                        <ContactAddressPreview
                                            contactData={{
                                                ...this._getRecipientContact(),
                                            }}
                                            contractualCountryId={this._getContractualCountryId()}
                                        />
                                    </Postit>
                                </Col>
                                <Col xs={8} sm={8} md={8} lg={8}>
                                    <div className="clearfix" />
                                    <div className="form-footer">
                                        {errorMessage}
                                        <Button
                                            type="submit"
                                            disabled={!this._isDataValid()}
                                            className="btn btn-primary pull-right"
                                        >
                                            {this.props.strings.finish}
                                        </Button>
                                    </div>
                                </Col>
                                <Col xs={4} sm={4} md={4} lg={4} />
                            </form>
                        </Row>
                    </Col>
                </Row>
            </Navbar>
        );
    }
}

export default connectR(
    (store) => ({
        userData: store.user.legacyUser,
        partnerManagerDetails: store.partnerManager.partnerManagerDetails,
        partners: store.partnerManager.getPartnersResult || [],
        createPartnerRequest: store.pbRequest[PbRequest.CREATE_PARTNER_REQUEST],
    }),
    {
        MaybeLoadCountries,
        LoadAccountingAreaDefaults,
        LoadSupportedTenants,
        LoadPartners,
        CreatePartner,
        PrepareCreatePartner,
    }
)(translate('CreatePartnerBasicForm')(CreatePartnerBasicForm));
